import KYC from "../../../jsx/components/Dashboard/KYC/kyc";

const KYCWrapper = () => {
  return <KYC />;
};

export default constore(KYCWrapper);
